import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiPublic, apiPrivate, setAccessToken, getAccessToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const res = await apiPublic.post("/auth/refresh");
            setAccessToken(res.data.access_token);
            setUser(res.data.user);
            return res.data;
        } catch (e) {
            setAccessToken(null);
            setUser(null);
            return null;
        }
    }, []);

    const exchangeCode = useCallback(async (code) => {
        const res = await apiPublic.post("/auth/exchange-code", { code });
        setAccessToken(res.data.access_token);
        setUser(res.data.user);
        return res.data;
    }, []);

    useEffect(() => {
        (async () => {
            await refresh();
            setLoading(false);
        })();
    }, [refresh]);

    const requestOtp = async (email) => {
        const res = await apiPublic.post("/auth/request-otp", { email });
        return res.data;
    };

    const verifyOtp = async (email, otp) => {
        const res = await apiPublic.post("/auth/verify-otp", { email, otp });
        setAccessToken(res.data.access_token);
        setUser(res.data.user);
        return res.data;
    };

    const logout = async () => {
        try { await apiPrivate.post("/auth/logout"); } catch {}
        setAccessToken(null);
        setUser(null);
    };

    const refreshUser = async () => {
        try {
            const res = await apiPrivate.get("/auth/me");
            setUser(res.data);
            return res.data;
        } catch { return null; }
    };

    return (
        <AuthContext.Provider value={{ user, loading, requestOtp, verifyOtp, logout, refreshUser, refresh, exchangeCode }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
